<template>
  <div>
    <div class="d-sm-flex justify-between mb-5">
      <v-btn
        v-if="filter != ''"
        elevation="0"
        height="43"
        class="font-weight-bold text-uppercase shadow-none btn-default btn-outline-default py-2 px-6 me-2 mb-sm-0 mb-2"
        color="transparent"
        small
        >Filter: {{ filter }}</v-btn
      >
      <div>
        <v-btn
          elevation="0"
          height="43"
          class="font-weight-bold text-uppercase btn-default btn-outline-default shadow-none py-2 px-6 me-2"
          color="transparent"
          small
          @click="showCancelAlert()"
        >
          <v-icon
            class="material-icons-round text-primary ms-auto mr-3"
            size="30"
          >
            refresh
          </v-icon>
          Zahlungen aktualisieren
        </v-btn>
      </div>
      <div class="d-flex ms-auto">
        <v-menu transition="slide-y-transition" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              elevation="0"
              height="43"
              class="font-weight-bold text-uppercase btn-default btn-outline-default shadow-none py-2 px-6 me-2"
              color="transparent"
              small
            >
              Filter
              <v-icon>ni ni-bold-down text-xs ms-1</v-icon>
            </v-btn>
          </template>

          <v-list class="py-0">
            <v-list-item
              class="list-item-hover-active py-2"
              @click="filter = 'Bestätigt'"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title
                  class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                >
                  Status: Bestätigt
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              class="list-item-hover-active pb-2"
              @click="filter = 'Offen'"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title
                  class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                >
                  Status: Offen
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              class="list-item-hover-active pb-2"
              @click="filter = 'Storniert'"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title
                  class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                >
                  Status: Storniert
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <hr class="horizontal dark" />
            <v-list-item
              class="list-item-hover-active py-2"
              @click="filter = 'POS-Verkauf'"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title
                  class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                >
                  Zahlungsart: POS-Verkauf
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              class="list-item-hover-active py-2"
              @click="filter = 'PayPal'"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title
                  class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                >
                  Zahlungsart: PayPal
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <hr class="horizontal dark" />
            <v-list-item
              class="list-item-hover-active py-2"
              @click="filter = ''"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title
                  class="text-danger ls-0 font-weight-600 mb-0"
                >
                  Filter entfernen
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          elevation="0"
          height="43"
          class="font-weight-bold text-uppercase btn-default btn-outline-default shadow-none py-2 px-6 me-2"
          color="transparent"
          small
          @click="csvExportEntries(event)"
        >
          <v-icon>ni ni-archive-2 me-1</v-icon>
          Export CSV
        </v-btn>
        <v-menu transition="slide-y-transition" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              elevation="0"
              height="43"
              class="font-weight-bold text-uppercase btn-default btn-outline-default shadow-none py-2 px-6 me-2"
              color="transparent"
              small
            >
              Nur Codes (CSV)
              <v-icon>ni ni-bold-down text-xs ms-1</v-icon>
            </v-btn>
          </template>
          <v-list class="py-0">
            <v-list-item class="list-item-hover-active py-2" @click="csvExportCodes(event, false)">
              <v-list-item-content class="pa-0">
                <v-list-item-title class="text-body-2 ls-0 text-typo font-weight-600 mb-0">
                  Gültige Tickets
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="list-item-hover-active py-2" @click="csvExportCodes(event, true)">
              <v-list-item-content class="pa-0">
                <v-list-item-title class="text-body-2 ls-0 text-typo font-weight-600 mb-0">
                  Alle Tickets
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <v-card class="card-shadow border-radius-xl">
      <v-overlay :value="loadingInvoices" absolute>
        <v-progress-circular
          indeterminate
          size="64"
          color="primary"
        ></v-progress-circular>
      </v-overlay>
      <div class="card-header-padding">
        <v-row class="mt-0 ml-1" justify="space-between">
          <h5 class="font-weight-bolder text-h5 text-typo">
            {{
              invoices.filter((invoice) =>
                filter != ""
                  ? filter == "Storniert"
                    ? invoice.canceled == true
                    : filter == "Bestätigt"
                    ? invoice.state == "approved"
                    : filter == "Offen"
                    ? invoice.state == "created"
                    : filter == "POS-Verkauf"
                    ? invoice.payment_method == "pos"
                    : filter == "PayPal"
                    ? invoice.payment_method != "pos"
                    : true
                  : true
              ).length
            }}
            Zahlungsvorgänge
          </h5>

          <div class="mr-2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  @click="refreshInvoices"
                  v-bind="attrs"
                  v-on="on"
                  class="material-icons-round text-primary ms-auto"
                  size="30"
                >
                  refresh
                </v-icon>
              </template>
              <span>Aktualisieren</span>
            </v-tooltip>
          </div>
        </v-row>
        <!-- <h5 class="font-weight-bold text-h5 text-typo mb-0">
          {{ event.entries.length }} Anmeldungen
        </h5> -->
      </div>

      <v-card-text class="px-0 py-0">
        <v-data-table
          :headers="headers"
          :item-class="getRowClass"
          :items="
            invoices.filter((invoice) =>
              filter != ''
                ? filter == 'Storniert'
                  ? invoice.canceled == true
                  : filter == 'Bestätigt'
                  ? invoice.state == 'approved'
                  : filter == 'Offen'
                  ? invoice.state == 'created'
                  : filter == 'POS-Verkauf'
                  ? invoice.payment_method == 'pos'
                  : filter == 'PayPal'
                  ? invoice.payment_method != 'pos'
                  : true
                : true
            )
          "
          :search="search"
          class="table"
          :page.sync="page"
          hide-default-footer
          @page-count="pageCount = $event"
          :items-per-page="itemsPerPage"
          mobile-breakpoint="0"
          item-key="_id"
        >
          <template v-slot:top>
            <v-toolbar flat height="80">
              <v-row>
                <v-col cols="12" md="5">
                  <v-text-field
                    hide-details
                    class="input-style font-size-input text-light-input placeholder-light input-icon"
                    dense
                    flat
                    filled
                    solo
                    height="43"
                    v-model="search"
                    placeholder="Suche"
                  >
                    <template slot="prepend-inner">
                      <v-icon
                        color="#adb5bd"
                        size="16"
                        class="material-icons-round mt-n2"
                        >search</v-icon
                      >
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <v-spacer></v-spacer>

              <v-dialog v-model="dialog" max-width="900px" scrollable>
                <v-card class="card-shadow border-radius-xl">
                  <!-- Header Section -->
                  <div class="card-header-padding card-border-bottom" style="background: linear-gradient(87deg, #5e72e4 0, #825ee4 100%);">
                    <div class="d-flex align-center justify-space-between">
                      <div>
                        <span class="font-weight-bold text-h5 text-white mb-0 d-block">{{
                          formTitle
                        }}</span>
                        <span class="text-white text-caption mt-1 d-block" v-if="editedItem.invoice_nr">
                          Rechnungsnummer: {{ editedItem.invoice_nr }}
                        </span>
                      </div>
                      <v-chip
                        :color="getStatusColor(editedItem)"
                        dark
                        small
                        class="font-weight-bold"
                      >
                        {{ getPaymentStatus(editedItem) }}
                      </v-chip>
                    </div>
                  </div>

                  <v-card-text class="card-padding">
                    <v-container class="px-0">
                      <!-- Rechnungsdaten Section -->
                      <div class="mb-6">
                        <h6 class="text-h6 text-typo mb-4 d-flex align-center">
                          <v-icon class="material-icons-round me-2" color="primary">person</v-icon>
                          Rechnungsdaten
                        </h6>
                        <v-row>
                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.eventPayload.firstname"
                            hide-details
                            disabled
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Vorname"
                            label="Vorname"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            disabled
                            v-model="editedItem.eventPayload.lastname"
                            hide-details
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Nachname"
                            label="Nachname"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="editedEmail"
                            hide-details
                            :disabled="savingEmail"
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="E-Mail-Adresse"
                            label="E-Mail-Adresse"
                            @blur="saveEmail"
                            @keyup.enter="saveEmail"
                          >
                            <template v-slot:append-outer>
                              <v-btn
                                v-if="editedEmail && editedEmail !== getCurrentEmailForPayment(editedItem)"
                                @click="saveEmail"
                                :loading="savingEmail"
                                icon
                                small
                                color="primary"
                              >
                                <v-icon small class="material-icons-round">save</v-icon>
                              </v-btn>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.eventPayload.street"
                            hide-details
                            disabled
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Straße"
                            label="Straße"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            :value="editedItem.eventPayload.number || '-'"
                            hide-details
                            disabled
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Hausnummer"
                            label="Hausnummer"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.eventPayload.zip"
                            hide-details
                            disabled
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Postleitzahl"
                            label="Postleitzahl"
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="editedItem.eventPayload.city"
                            hide-details
                            disabled
                            class="input-style font-size-input text-light-input placeholder-light input-icon"
                            dense
                            flat
                            outlined
                            height="43"
                            placeholder="Ort"
                            label="Ort"
                          ></v-text-field>
                        </v-col>
                        </v-row>
                      </div>

                      <!-- Zahlungsinformationen Section -->
                      <div class="mb-6">
                        <h6 class="text-h6 text-typo mb-4 d-flex align-center">
                          <v-icon class="material-icons-round me-2" color="primary">payment</v-icon>
                          Zahlungsinformationen
                        </h6>
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-text-field
                              :value="getPaymentMethodLabel(editedItem)"
                              hide-details
                              disabled
                              class="input-style font-size-input text-light-input placeholder-light input-icon"
                              dense
                              flat
                              outlined
                              height="43"
                              label="Zahlungsart"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              :value="getSource(editedItem)"
                              hide-details
                              disabled
                              class="input-style font-size-input text-light-input placeholder-light input-icon"
                              dense
                              flat
                              outlined
                              height="43"
                              label="Quelle"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6" v-if="editedItem.transactions && editedItem.transactions[0] && editedItem.transactions[0].related_resources && editedItem.transactions[0].related_resources[0]">
                            <v-text-field
                              :value="editedItem.transactions[0].related_resources[0].sale ? editedItem.transactions[0].related_resources[0].sale.id : '-'"
                              hide-details
                              disabled
                              class="input-style font-size-input text-light-input placeholder-light input-icon"
                              dense
                              flat
                              outlined
                              height="43"
                              label="Zahlungs-ID"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              :value="formatPrice(editedItem.transactions && editedItem.transactions[0] && editedItem.transactions[0].amount ? editedItem.transactions[0].amount.total : 0) + ' €'"
                              hide-details
                              disabled
                              class="input-style font-size-input text-light-input placeholder-light input-icon"
                              dense
                              flat
                              outlined
                              height="43"
                              label="Rechnungsbetrag"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </div>

                      <!-- Rabatt/Aufschlag Section -->
                      <div class="mb-6" v-if="editedItem.discount && editedItem.discount.amount > 0">
                        <h6 class="text-h6 text-typo mb-4 d-flex align-center">
                          <v-icon class="material-icons-round me-2" :color="editedItem.discount.mode === 'surcharge' ? 'warning' : 'success'">
                            {{ editedItem.discount.mode === 'surcharge' ? 'trending_up' : 'trending_down' }}
                          </v-icon>
                          {{ editedItem.discount.mode === 'surcharge' ? 'Aufschlag' : 'Rabatt' }}
                        </h6>
                        <v-card outlined class="border-radius-lg pa-4" :class="editedItem.discount.mode === 'surcharge' ? 'border-warning' : 'border-success'">
                          <v-row>
                            <v-col cols="12" md="6">
                              <v-text-field
                                :value="editedItem.discount.type === 'percent' ? editedItem.discount.value + '%' : formatPrice(editedItem.discount.value) + ' €'"
                                hide-details
                                disabled
                                class="input-style font-size-input text-light-input placeholder-light input-icon"
                                dense
                                flat
                                outlined
                                height="43"
                                :label="editedItem.discount.type === 'percent' ? 'Prozentsatz' : 'Betrag'"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-text-field
                                :value="formatPrice(editedItem.discount.amount) + ' €'"
                                hide-details
                                disabled
                                class="input-style font-size-input text-light-input placeholder-light input-icon"
                                dense
                                flat
                                outlined
                                height="43"
                                label="Rabatt/Aufschlag Betrag"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" v-if="editedItem.discount.reason">
                              <v-text-field
                                :value="editedItem.discount.reason"
                                hide-details
                                disabled
                                class="input-style font-size-input text-light-input placeholder-light input-icon"
                                dense
                                flat
                                outlined
                                height="43"
                                label="Grund"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" v-if="editedItem.discount.subtotal">
                              <v-text-field
                                :value="formatPrice(editedItem.discount.subtotal) + ' €'"
                                hide-details
                                disabled
                                class="input-style font-size-input text-light-input placeholder-light input-icon"
                                dense
                                flat
                                outlined
                                height="43"
                                label="Zwischensumme (vor Rabatt/Aufschlag)"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-card>
                      </div>

                      <!-- Positionen Section -->
                      <div class="mb-6" v-if="getInvoiceItems(editedItem).length > 0">
                        <h6 class="text-h6 text-typo mb-4 d-flex align-center">
                          <v-icon class="material-icons-round me-2" color="primary">receipt</v-icon>
                          Positionen
                        </h6>
                        <v-card outlined class="border-radius-lg">
                          <v-simple-table dense>
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left font-weight-bold">Beschreibung</th>
                                  <th class="text-right font-weight-bold">Menge</th>
                                  <th class="text-right font-weight-bold">Einzelpreis</th>
                                  <th class="text-right font-weight-bold">Gesamt</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(item, index) in getInvoiceItems(editedItem)" :key="index">
                                  <td>{{ item.description || item.name || '-' }}</td>
                                  <td class="text-right">{{ item.quantity || 1 }}</td>
                                  <td class="text-right">{{ formatPrice(item.price) }} €</td>
                                  <td class="text-right font-weight-bold">{{ formatPrice((item.price || 0) * (item.quantity || 1)) }} €</td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-card>
                      </div>
                      </v-row>

                      <!-- Zahlung eingegangen Button (nur bei offenen POS-Rechnungen) -->
                      <v-alert
                        v-if="editedItem.state === 'created' && editedItem.payment_method === 'pos' && editedItem.payment_mode === 'invoice'"
                        type="info"
                        dense
                        text
                        class="mt-4 mb-0"
                      >
                        <div class="d-flex align-center justify-space-between">
                          <div>
                            <small class="text-typo">
                              <strong>Rechnung offen:</strong> Bestätige den Zahlungseingang, sobald die Überweisung eingegangen ist.
                            </small>
                          </div>
                          <v-btn
                            @click="markPaymentAsReceived()"
                            elevation="0"
                            :ripple="false"
                            height="40"
                            :loading="markingAsPaid"
                            class="font-weight-bold btn-ls bg-gradient-success text-white text-uppercase px-4 ml-3"
                          >
                            <i class="material-icons-round me-2" style="font-size: 18px;">check_circle</i>
                            Zahlung eingegangen
                          </v-btn>
                        </div>
                      </v-alert>
                    </v-container>
                  </v-card-text>

                  <v-divider></v-divider>

                  <!-- Aktionen Section -->
                  <v-divider></v-divider>
                  <v-card-actions class="card-padding">
                    <v-row>
                      <v-col cols="12" class="pb-2">
                        <div class="d-flex flex-wrap">
                          <v-btn
                            @click="downloadInvoiceModal(editedItem)"
                            elevation="0"
                            :ripple="false"
                            height="43"
                            class="font-weight-normal text-capitalize btn-ls btn-primary bg-gradient-info py-3 px-6 mr-2 mb-2"
                          >
                            <v-icon class="material-icons-round me-2" size="18">download</v-icon>
                            Rechnung herunterladen
                          </v-btn>
                          <v-btn
                            v-if="canResendEmail(editedItem)"
                            @click="resendTicketEmail(editedItem)"
                            elevation="0"
                            :ripple="false"
                            height="43"
                            :loading="resendingEmail"
                            :disabled="resendingEmail"
                            class="font-weight-normal text-capitalize btn-ls btn-primary py-3 px-6 mr-2 mb-2"
                            :class="emailResended === editedItem._id ? 'bg-gradient-success' : 'bg-gradient-primary'"
                          >
                            <v-icon class="material-icons-round me-2" size="18">{{ emailResended === editedItem._id ? 'check_circle' : 'email' }}</v-icon>
                            {{ emailResended === editedItem._id ? 'E-Mail gesendet!' : 'Ticket-E-Mail erneut senden' }}
                          </v-btn>
                          <v-btn
                            @click="showPaymentAlert()"
                            elevation="0"
                            :ripple="false"
                            height="43"
                            :disabled="
                              refundValidation(editedItem.create_time) ||
                              editedItem.canceled
                            "
                            class="font-weight-normal btn-ls btn-primary bg-danger py-3 px-6 mb-2"
                          >
                            <v-icon class="material-icons-round me-2" size="18">cancel</v-icon>
                            {{
                              editedItem.canceled
                                ? "Storniert"
                                : !refundValidation(editedItem.create_time)
                                ? "Rechnung stornieren"
                                : "Storno nicht mehr möglich"
                            }}
                          </v-btn>
                        </div>
                      </v-col>
                      <v-col cols="12" class="d-flex justify-end pt-2">
                        <v-btn
                          @click="close"
                          elevation="0"
                          :ripple="false"
                          height="43"
                          class="font-weight-normal text-capitalize btn-ls btn-outline-secondary bg-transparent py-3 px-6"
                        >
                          schließen
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="cancelationDialog" max-width="600px">
                <v-card class="card-shadow border-radius-xl">
                  <div class="card-header-padding card-border-bottom">
                    <span class="font-weight-bold text-h5 text-typo mb-0"
                      >Rechnung stornieren</span
                    >
                  </div>
                  <v-card-text class="card-padding">
                    <v-container class="px-0">
                      <span
                        class="font-weight-bold text-h5 text-danger text--danger mb-0"
                        >Möchten Sie die Rechnung wirklich stornieren? Dieser
                        Vorgang kann nicht rückgängig gemacht werden! 
                        <span v-if="editedItem.payment_method === 'pos'">
                          Eine manuelle Rückerstattung (falls bereits bezahlt) muss separat erfolgen.
                        </span>
                        <span v-else>
                          Es wird eine Rückerstattung bei PayPal angefordert!
                        </span>
                      </span
                      >
                    </v-container>
                  </v-card-text>

                  <v-card-actions class="card-padding d-flex justify-end">
                    <v-btn
                      @click="showPaymentAlert"
                      elevation="0"
                      :ripple="false"
                      height="43"
                      class="font-weight-normal text-capitalize btn-ls btn-primary bg-danger py-3 px-6"
                      >Rechnung endgültig stornieren</v-btn
                    >
                    <v-btn
                      @click="closeCancelation"
                      elevation="0"
                      :ripple="false"
                      height="43"
                      class="font-weight-normal text-capitalize btn-ls btn-outline-secondary bg-transparent py-3 px-6"
                      >abbrechen</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="updatingStates" persistent max-width="600px">
                <v-card class="card-shadow border-radius-xl">
                  <div class="card-header-padding card-border-bottom">
                    <span class="font-weight-bold text-h5 text-typo mb-0"
                      >Zahlungsvorgänge werden aktualisiert</span
                    >
                  </div>
                  <v-card-text class="card-padding">
                    <span class="font-weight-bold text-body text-typo mb-0"
                      >Dies wird einige Zeit in Anspruch nehmen, schließen Sie
                      dieses Fenster nicht bevor der Vorgang beendet
                      wurde!</span
                    >

                    <v-progress-linear
                      v-if="updatingStates"
                      class="mt-4 mr-5"
                      color="light-blue"
                      height="10"
                      :value="progressValue"
                      rounded
                    ></v-progress-linear>
                  </v-card-text>
                </v-card>
              </v-dialog>

              <v-dialog v-model="dialogNoInvoice" max-width="500px">
                <v-card class="card-shadow card-padding border-radius-xl">
                  <v-card-title class="pt-0 text-h5 text-typo justify-center"
                    >Keine Rechnung vorhanden</v-card-title
                  >
                  <v-card-actions class="pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                      @click="closeNoInvoice"
                      elevation="0"
                      :ripple="false"
                      height="43"
                      class="font-weight-normal text-capitalize btn-ls bg-transparent btn-outline-secondary py-3 px-6"
                      >schließen</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:item.payer.payer_info.first_name="{ item }">
            <div class="d-flex align-center ms-2">
              <span class="text-sm font-weight-normal text-body">
                {{
                  item.payer.payer_info
                    ? item.payer.payer_info.first_name
                    : "- - -"
                }}
              </span>
            </div>
          </template>

          <template v-slot:item.payer.payer_info.last_name="{ item }">
            <div class="d-flex align-center ms-2">
              <span class="text-sm font-weight-normal text-body">
                {{
                  item.payer.payer_info
                    ? item.payer.payer_info.last_name
                    : "- - -"
                }}
              </span>
            </div>
          </template>

          <template v-slot:item.invoice_nr="{ item }">
            <span class="text-sm font-weight-normal text-body">
              {{ item.invoice_nr ? item.invoice_nr : "- - -" }}
            </span>
          </template>

          <template v-slot:item.create_time="{ item }">
            <span class="text-sm font-weight-normal text-body">
              {{ item.create_time | moment("DD.MM.YYYY HH:mm") }}
            </span>
          </template>

          <template v-slot:item.state="{ item }">
            <span class="text-sm font-weight-normal text-body">
              {{ item.state }}
            </span>
          </template>

          <template v-slot:item.transactions[0].amount.total="{ item }">
            <span class="text-sm font-weight-normal text-body">
              {{ item.transactions[0].amount.total }}€
            </span>
          </template>

          <!-- Neue Zahlungsart Spalte -->
          <template v-slot:item.payment_method="{ item }">
            <div class="d-flex justify-center">
              <!-- POS-Verkauf -->
              <v-chip
                v-if="item.payment_method === 'pos'"
                x-small
                :color="getPaymentModeColor(item.payment_mode)"
                text-color="white"
                class="font-weight-bold"
              >
                {{ getPaymentModeLabel(item.payment_mode) }}
              </v-chip>
              <!-- PayPal -->
              <v-chip
                v-else
                x-small
                color="blue"
                text-color="white"
                class="font-weight-bold"
              >
                PAYPAL
              </v-chip>
            </div>
          </template>

          <!-- Quelle (Source) Spalte -->
          <template v-slot:item.source="{ item }">
            <!-- POS -->
            <v-tooltip bottom v-if="item.source === 'pos' || item.payment_method === 'pos'">
              <template v-slot:activator="{ on, attrs }">
                <v-avatar
                  size="28"
                  color="#00897B"
                  v-bind="attrs"
                  v-on="on"
                >
                  <i class="material-icons-round text-white" style="font-size: 16px;">point_of_sale</i>
                </v-avatar>
              </template>
              <span v-if="item.createdByName">POS-Verkauf durch: {{ item.createdByEmail || item.createdByName }}</span>
              <span v-else>POS-Verkauf</span>
            </v-tooltip>
            <!-- App -->
            <v-tooltip bottom v-else-if="item.source === 'app'">
              <template v-slot:activator="{ on, attrs }">
                <v-avatar
                  size="28"
                  color="#FF6F00"
                  v-bind="attrs"
                  v-on="on"
                >
                  <i class="material-icons-round text-white" style="font-size: 16px;">phone_iphone</i>
                </v-avatar>
              </template>
              <span>Ticket-App</span>
            </v-tooltip>
            <!-- Website (default) -->
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on, attrs }">
                <v-avatar
                  size="28"
                  color="#5E35B1"
                  v-bind="attrs"
                  v-on="on"
                >
                  <i class="material-icons-round text-white" style="font-size: 16px;">language</i>
                </v-avatar>
              </template>
              <span>Website</span>
            </v-tooltip>
          </template>

          <!-- PayPal Status Spalte (nur für PayPal-Transaktionen) -->
          <template v-slot:item.transactions[0].related_resources="{ item }">
            <span
              v-if="item.transactions[0].related_resources"
              class="text-sm font-weight-normal"
              :class="
                getPaypalState(
                  item.transactions[0].related_resources[0].sale.state
                ) != 'ABGESCHLOSSEN'
                  ? 'text-danger'
                  : 'text-success'
              "
            >
              {{
                item.transactions[0].related_resources
                  ? getPaypalState(
                      item.transactions[0].related_resources[0].sale.state
                    )
                  : ""
              }}
            </span>
            <span v-else class="text-xs text-secondary">-</span>
          </template>

          <template v-slot:item.state="{ item }">
            <div class="d-flex align-center">
              <v-btn
                :ripple="false"
                icon
                outlined
                disabled
                rounded
                width="25px"
                height="25px"
                class="me-2"
                :class="
                  item.canceled
                    ? 'border-danger'
                    : item.state == 'approved'
                    ? 'border-success'
                    : item.state == 'created'
                    ? 'border-warning'
                    : 'border-default'
                "
              >
                <v-icon
                  size="8"
                  :class="
                    item.state == 'approved' 
                      ? 'text-success' 
                      : item.state == 'created'
                      ? 'text-warning'
                      : 'text-dark'
                  "
                >
                  {{
                    item.canceled
                      ? "fas fa-times"
                      : item.state == "approved"
                      ? "fas fa-check"
                      : item.state == "created"
                      ? "fas fa-clock"
                      : "fas fa-times"
                  }}
                </v-icon>
              </v-btn>
              <span
                class="text-body text-xs"
                :class="
                  item.canceled
                    ? 'text-danger'
                    : item.state == 'approved'
                    ? 'text-success'
                    : item.state == 'created'
                    ? 'text-warning'
                    : ''
                "
                >{{
                  item.cancelation_invoice
                    ? "Stornorechnung"
                    : item.canceled
                    ? "Storniert"
                    : item.state == "approved"
                    ? "Bestätigt"
                    : ""
                }}
                {{ 
                  item.state == "created" 
                    ? (item.payment_method === "pos" && item.payment_mode === "invoice" 
                        ? "Offen (Rechnung)" 
                        : "Offen") 
                    : "" 
                }}</span
              >
            </div>
          </template>

          <template v-slot:item._id="{ item }">
            <v-btn
              v-if="item.invoice_nr"
              @click="editItem(item)"
              icon
              elevation="0"
              :ripple="false"
              height="28"
              min-width="36"
              width="36"
              class="btn-ls me-2 my-2 rounded-sm"
              color="#67748e"
            >
              <v-icon size="25" class="material-icons-round">search</v-icon>
            </v-btn>

            <v-btn
              v-if="item.invoice_nr"
              @click="downloadInvoiceModal(item)"
              icon
              elevation="0"
              :ripple="false"
              height="28"
              min-width="36"
              width="36"
              class="btn-ls me-2 my-2 rounded-sm"
              color="#67748e"
            >
              <v-icon size="25" class="material-icons-round">download</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="card-padding">
        <v-row>
          <v-col cols="6" lg="3" class="d-flex align-center">
            <span class="text-body me-3 text-sm">Einträge pro Seite:</span>
            <v-text-field
              hide-details
              type="number"
              outlined
              min="-1"
              max="15"
              background-color="rgba(255,255,255,.9)"
              color="rgba(0,0,0,.6)"
              light
              :value="itemsPerPage"
              @input="itemsPerPage = parseInt($event, 10)"
              placeholder="Items per page"
              class="font-size-input placeholder-lighter text-color-light input-alternative input-focused-alternative input-icon"
            >
            </v-text-field>
          </v-col>
          <v-col cols="6" class="ml-auto d-flex justify-end">
            <v-pagination
              prev-icon="fa fa-angle-left"
              next-icon="fa fa-angle-right"
              class="pagination"
              color="#D81B60"
              v-model="page"
              :length="pageCount"
              circle
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import users from "./Users";
import coreData from "@/mixins/coreDataMixin";
import axiosAuth from "@/shared/configs/axios-auth";
import { mapGetters } from 'vuex';

export default {
  name: "paginated-tables",
  mixins: [coreData],
  data() {
    return {
      progressValue: 0,
      updatingStates: false,
      markingAsPaid: false,
      resendingEmail: false,
      editingEmail: false,
      editedEmail: '',
      savingEmail: false,
      filter: "Bestätigt",
      dialogNoInvoice: false,
      showParticipantsDialog: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      dialog: false,
      dialogDelete: false,
      cancelationDialog: false,
      users,
      search: "",
      editedIndex: -1,
      editedItem: {
        eventPayload: {},
      },
      defaultItem: {
        eventPayload: {},
      },
      headers: [
        {
          text: "Vorname",
          value: "payer.payer_info.first_name",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Nachname",
          value: "payer.payer_info.last_name",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Rechnugnsnummer",
          align: "start",
          cellClass: "border-bottom",
          sortable: true,
          value: "invoice_nr",
          class:
            "text-secondary font-weight-bolder opacity-7 border-bottom ps-6",
        },
        {
          text: "Datum",
          value: "create_time",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Status",
          value: "state",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Zahlungsart",
          value: "payment_method",
          sortable: true,
          align: "center",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Quelle",
          value: "source",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Zahlungsstatus",
          value: "transactions[0].related_resources",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Betrag",
          value: "transactions[0].amount.total",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Aktionen",
          value: "_id",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
      ],
    };
  },
  methods: {
    refreshInvoices() {
      if (this.event && this.event._id) {
        this.$store.dispatch('getInvoices', this.event._id);
      }
    },
    getRowClass(item) {
      if (item.canceled || item.cancelation_invoice) {
        console.log('🔴 Canceled invoice detected:', item.invoice_nr, 'canceled:', item.canceled, 'cancelation_invoice:', item.cancelation_invoice);
        return 'table-row-canceled';
      }
      return '';
    },
    getPaymentMethodLabel(item) {
      if (!item) return 'N/A';
      
      if (item.payment_method === 'pos') {
        // POS-Verkauf
        const modeLabels = {
          'cash': 'Bar',
          'electronic': 'Elektronisch',
          'invoice': 'Rechnung'
        };
        const mode = item.payment_mode || 'Bar';
        return `POS: ${modeLabels[mode] || mode}`;
      } else {
        // PayPal
        return 'PayPal';
      }
    },
    getSource(item) {
      if (!item || !item.source) return '-';
      
      const sourceMap = {
        'pos': 'POS-Verkauf',
        'app': 'Ticket-App',
        'website': 'Website'
      };
      return sourceMap[item.source] || item.source;
    },
    getPaymentStatus(item) {
      if (!item) return '-';
      
      if (item.transactions && item.transactions[0] && item.transactions[0].related_resources) {
        const sale = item.transactions[0].related_resources[0].sale;
        if (sale && sale.state) {
          const stateMap = {
            'completed': 'Abgeschlossen',
            'pending': 'Ausstehend',
            'refunded': 'Erstattet',
            'partially_refunded': 'Teilweise erstattet'
          };
          return stateMap[sale.state] || sale.state;
        }
      }
      
      // Fallback: use payment state if available
      if (item.state) {
        const stateMap = {
          'approved': 'Bestätigt',
          'created': 'Erstellt',
          'canceled': 'Storniert'
        };
        return stateMap[item.state] || item.state;
      }
      
      return '-';
    },
    getInvoiceItems(item) {
      if (!item || !item.transactions || !item.transactions[0] || !item.transactions[0].item_list || !item.transactions[0].item_list.items) {
        return [];
      }
      return item.transactions[0].item_list.items;
    },
    formatPrice(price) {
      if (!price) return '0.00';
      return parseFloat(price).toFixed(2);
    },
    getStatusColor(item) {
      if (!item) return 'grey';
      if (item.canceled) return 'error';
      if (item.state === 'approved') return 'success';
      if (item.state === 'created') return 'warning';
      return 'grey';
    },
    getCurrentEmailForPayment(item) {
      if (!item || !item._id) return '';
      
      // Get email from event entries (the email that is actually used for sending)
      if (this.event && this.event.entries) {
        const entries = this.event.entries.filter(entry => 
          entry.payment_id && 
          Array.isArray(entry.payment_id) && 
          entry.payment_id.some(paymentId => 
            paymentId && (paymentId._id ? paymentId._id.toString() : paymentId.toString()) === item._id.toString()
          )
        );
        
        // Use email from first entry (they should all have the same email)
        if (entries.length > 0 && entries[0].email) {
          return entries[0].email;
        }
      }
      
      // Fallback to payment.eventPayload.email if no entry email found
      if (item.eventPayload && item.eventPayload.email) {
        return item.eventPayload.email;
      }
      
      return '';
    },
    canResendEmail(item) {
      if (!item || !item._id) return false;
      // Check if payment exists and is approved
      if (item.state !== 'approved' || item.canceled) return false;
      
      // If this is the currently edited item and we have an edited email, use that
      if (this.editedItem && this.editedItem._id && item._id && 
          this.editedItem._id.toString() === item._id.toString() && 
          this.editedEmail) {
        const email = this.editedEmail;
        if (!email) return false;
        // Validate edited email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
          return false; // Invalid format
        }
        // Check for temporary/invalid email patterns
        if (email.includes('@temp.local') || email.includes('@temp.') || !email.includes('@')) {
          return false;
        }
        return true;
      }
      
      // Get email from event entries (the email that is actually used for sending)
      let email = null;
      if (this.event && this.event.entries) {
        const entries = this.event.entries.filter(entry => 
          entry.payment_id && 
          Array.isArray(entry.payment_id) && 
          entry.payment_id.some(paymentId => 
            paymentId && (paymentId._id ? paymentId._id.toString() : paymentId.toString()) === item._id.toString()
          )
        );
        
        // Use email from first entry (they should all have the same email)
        if (entries.length > 0 && entries[0].email) {
          email = entries[0].email;
        }
      }
      
      // Fallback to payment.eventPayload.email if no entry email found
      if (!email && item.eventPayload && item.eventPayload.email) {
        email = item.eventPayload.email;
      }
      
      if (!email) return false;
      
      // Check for temporary/invalid email patterns
      if (email.includes('@temp.local') || email.includes('@temp.') || !email.includes('@')) {
        return false;
      }
      
      return true;
    },
    async resendTicketEmail(item) {
      if (!item || !item._id) return;
      
      // Prevent multiple clicks
      if (this.resendingEmail) {
        console.log('⚠️ [RESEND EMAIL] Already sending, ignoring click');
        return;
      }
      
      console.log('📧 [RESEND EMAIL] Starting email resend for payment:', item._id);
      
      // Set loading state reactively
      this.$set(this, 'resendingEmail', true);
      
      try {
        // Find event entries that have this payment_id
        let entries = [];
        if (this.event && this.event.entries) {
          entries = this.event.entries.filter(entry => 
            entry.payment_id && 
            Array.isArray(entry.payment_id) && 
            entry.payment_id.some(paymentId => 
              paymentId && (paymentId._id ? paymentId._id.toString() : paymentId.toString()) === item._id.toString()
            )
          );
        }
        
        if (entries.length === 0) {
          console.log('⚠️ [RESEND EMAIL] No entries found for payment');
          this.SnackbarShow('Warning', '', 'Keine Tickets für diese Rechnung gefunden.');
          this.$set(this, 'resendingEmail', false);
          return;
        }
        
        console.log('📧 [RESEND EMAIL] Found', entries.length, 'entries, sending email for first entry');
        
        // Get email from entry or payment
        const entry = entries[0];
        const email = entry.email || (item.eventPayload && item.eventPayload.email) || '';
        const name = entry.firstname && entry.lastname 
          ? `${entry.firstname} ${entry.lastname}` 
          : (item.eventPayload && item.eventPayload.name) || '';
        
        // Build payload according to backend expectations
        const payload = {
          event: this.event._id,
          user: entry.user || entry._id,
          name: name,
          email: email,
          payment_id: [{ _id: item._id }],
          _id: item._id // Store payment ID for tracking
        };
        
        console.log('📧 [RESEND EMAIL] Sending payload:', payload);
        
        // Use the first entry to send email - the backend will handle all tickets for this payment
        // Only send ONE email per payment, not one per entry
        await this.resendEmail(payload);
        
        console.log('✅ [RESEND EMAIL] Email sent successfully');
        
        // Wait for Vue to update the reactive state
        await this.$nextTick();
        
        // emailResended is now set in the store by resendEmail action
        this.SnackbarShow('Success', '', 'Ticket-E-Mail erfolgreich gesendet!');
      } catch (error) {
        console.error('❌ [RESEND EMAIL] Error resending email:', error);
        this.SnackbarShow('Error', '', 'Fehler beim Senden der E-Mail: ' + (error.response?.data?.message || error.message || 'Unbekannter Fehler'));
      } finally {
        console.log('🔄 [RESEND EMAIL] Resetting resendingEmail flag');
        this.$set(this, 'resendingEmail', false);
      }
    },
    async saveEmail() {
      if (!this.editedItem || !this.editedItem._id) {
        return;
      }
      
      const currentEmail = this.getCurrentEmailForPayment(this.editedItem);
      if (this.editedEmail === currentEmail || this.editedEmail === '') {
        return; // No change
      }
      
      // Validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.editedEmail)) {
        this.SnackbarShow('Error', '', 'Ungültiges E-Mail-Format');
        this.editedEmail = currentEmail; // Reset to original
        return;
      }
      
      this.savingEmail = true;
      try {
        // Find event entries that have this payment_id
        let entries = [];
        if (this.event && this.event.entries) {
          entries = this.event.entries.filter(entry => 
            entry.payment_id && 
            Array.isArray(entry.payment_id) && 
            entry.payment_id.some(paymentId => 
              paymentId && (paymentId._id ? paymentId._id.toString() : paymentId.toString()) === this.editedItem._id.toString()
            )
          );
        }
        
        if (entries.length === 0) {
          this.SnackbarShow('Warning', '', 'Keine Tickets für diese Rechnung gefunden.');
          this.editedEmail = currentEmail; // Reset to original
          return;
        }
        
        // Update email for each entry - only send email field
        for (const entry of entries) {
          await axiosAuth.patch(`/events/entry/${entry._id}/email`, {
            email: this.editedEmail
          });
        }
        
        // Refresh event to get updated data
        if (this.event && this.event._id) {
          await this.$store.dispatch('getEventByIdAdmin', this.event._id);
        }
        
        this.SnackbarShow('Success', '', 'E-Mail-Adresse erfolgreich aktualisiert');
      } catch (error) {
        console.error('Error updating email:', error);
        this.SnackbarShow('Error', '', 'Fehler beim Aktualisieren der E-Mail-Adresse');
        // Reset to original email on error
        this.editedEmail = currentEmail;
      } finally {
        this.savingEmail = false;
      }
    },
    async updatePayments() {
      this.updatingStates = true;
      this.progressValue = 0;
      let invoices = this.invoices.filter(
        (invoice) => invoice.state == "approved"
      );
      let counter = 1;
      for (const element of invoices) {
        await axiosAuth
          .get("invoices/paypal-details/" + element.id)
          .then(() => {
            counter += 1;
            console.log(element.id);
            this.progressValue = (100 * counter) / invoices.length;
          })
          .catch((error) => {
            this.SnackbarShow("Danger", "Fehler!");
          });
      }
      this.updatingStates = false;
      this.$store.dispatch("getInvoices", this.event._id);
      this.$swal(
        "Vorgang beendet",
        "Die Zahlungsvorgänge wurden aktualisiert",
        "success"
      );
    },
    showCancelAlert() {
      this.$swal({
        title: "Wollen Sie alle Zahlungsvorgänge aktualisieren?",
        text: `Dies wird einige Zeit (ca. ${this.estimatedRefreshTime}, je nach Verbindung und Auslastung des Servers) in Anspruch nehmen, schließen Sie dieses Fenster nicht bevor der Vorgang beendet wurde!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ja, jetzt aktualisieren",
        cancelButtonText: "Nein, abbrechen",
        customClass: {
          confirmButton: "btn bg-gradient-success",
          cancelButton: "btn bg-gradient-danger",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.updatePayments();
        }
      });
    },
    showPaymentAlert() {
      const isPosPayment = this.editedItem.payment_method === 'pos';
      
      const warningText = isPosPayment
        ? "Möchten Sie die Rechnung wirklich stornieren? Dieser Vorgang kann nicht rückgängig gemacht werden! Eine manuelle Rückerstattung (falls bereits bezahlt) muss separat erfolgen."
        : "Möchten Sie die Rechnung wirklich stornieren? Dieser Vorgang kann nicht rückgängig gemacht werden! Es wird eine Rückerstattung bei PayPal angefordert!";
      
      const successText = isPosPayment
        ? "Die Rechnung sowie zugehörige Tickets wurden storniert! Falls bereits eine Zahlung eingegangen ist, muss die Rückerstattung manuell erfolgen."
        : "Die Rechnung sowie zugehörige Tickets wurden storniert! Sofern eine Erstattung möglich ist, wird diese eingeleitet.";
      
      this.$swal({
        title: "Rechnung stornieren",
        text: warningText,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ja, Rechnung stornieren",
        cancelButtonText: "Nein, abbrechen",
        customClass: {
          confirmButton: "btn bg-gradient-success",
          cancelButton: "btn bg-gradient-danger",
        },
      }).then((result) => {
        if (result.value) {
          this.dialog = false;
          this.cancelInvoice();
          this.$swal.fire(
            "Storniert!",
            successText,
            "success"
          );
        } else if (result.dismiss === this.$swal.DismissReason.cancel) {
          this.$swal.fire(
            "Abgebrochen",
            "Der Vorgang wurde nicht ausgeführt",
            "error"
          );
        }
      });
    },
    // showWarningAlert() {
    //   this.$swal({
    //     title: "Wollen Sie alle Zahlungsvorgänge aktualisieren?",
    //     text: "Dies wird einige Zeit in Anspruch nehmen, schließen Sie dieses Fenster nicht bevor der Vorgang beendet wurde!",
    //     type: "warning",
    //     showCancelButton: true,
    //     customClass: {
    //       confirmButton: "btn bg-gradient-success",
    //       cancelButton: "btn bg-gradient-danger",
    //     },
    //     confirmButtonText: "Ja, aktualisieren.",
    //     cancelButtonText: "Nein, abbrechen",
    //     reverseButtons: true,
    //   }).then((result) => {
    //     if (result.value) {
    //       this.updatePayments()
    //     } else if (
    //       /* Read more about handling dismissals below */
    //       result.dismiss === this.$swal.DismissReason.cancel
    //     ) {
    //       this.$swal.fire(
    //         "Abgebrochen",
    //         "Der Vorgang wurde nicht ausgeführt",
    //         "error"
    //       );
    //     }
    //   });
    // },

    refundValidation(date) {
      let d = new Date();
      d.setDate(d.getDate() - 180);
      return Date.parse(date) < d;
    },
    cancelInvoice() {
      this.$store.dispatch("updateInvoices", {
        id: this.editedItem._id,
        eventId: this.event._id,
      });
      this.close();
      this.closeCancelation();
    },

    async markPaymentAsReceived() {
      try {
        this.markingAsPaid = true;

        await axiosAuth.patch(`/invoices/${this.editedItem._id}/status`, {
          state: 'approved'
        });

        this.SnackbarShow('Success', 'Erfolgreich!', 'Zahlung wurde als eingegangen markiert.');
        
        // Rechnung aktualisieren
        this.editedItem.state = 'approved';
        this.editedItem.update_time = new Date();
        
        // Invoices neu laden
        await this.getInvoices(this.event._id);
        
        this.close();

      } catch (error) {
        console.error('Error marking payment as received:', error);
        const message = (error.response && error.response.data && error.response.data.message) 
          || 'Fehler beim Aktualisieren des Zahlungsstatus';
        this.SnackbarShow('Danger', 'Fehler', message);
      } finally {
        this.markingAsPaid = false;
      }
    },

    editItem(item) {
      console.log(item);
      this.editedItem = item;
      
      // Get email from event entries (the email that is actually used for sending)
      let emailToShow = '';
      if (this.event && this.event.entries) {
        const entries = this.event.entries.filter(entry => 
          entry.payment_id && 
          Array.isArray(entry.payment_id) && 
          entry.payment_id.some(paymentId => 
            paymentId && (paymentId._id ? paymentId._id.toString() : paymentId.toString()) === item._id.toString()
          )
        );
        
        // Use email from first entry (they should all have the same email)
        if (entries.length > 0 && entries[0].email) {
          emailToShow = entries[0].email;
        }
      }
      
      // Fallback to payment.eventPayload.email if no entry email found
      if (!emailToShow && item.eventPayload && item.eventPayload.email) {
        emailToShow = item.eventPayload.email;
      }
      
      this.editedEmail = emailToShow;
      this.dialog = true;
    },

    showParticipants(item) {
      this.editedItem = item;
      // this.editedItem = Object.assign({}, item);
      this.showParticipantsDialog = true;
    },
    deleteItemConfirm() {
      this.users.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.showParticipantsDialog = false;
      this.editedEmail = '';
      this.$store.commit('emailResended', null);
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },

    closeCancelation() {
      this.cancelationDialog = false;
      this.showParticipantsDialog = false;
    },

    closeNoInvoice() {
      this.dialogNoInvoice = false;
      // this.$nextTick(() => {
      //   this.editedItem = Object.assign({}, this.defaultItem);
      // });
    },

    downloadInvoiceModal(item) {
      console.log(item);
      if (!item.invoice_nr) {
        this.dialogNoInvoice = true;
      } else {
        this.downloadInvoice(item);
      }
    },

    save() {
      // if (this.editedIndex > -1) {
      //   Object.assign(this.users[this.editedIndex], this.editedItem);
      // } else {
      //   this.users.push(this.editedItem);
      // }
      this.updateEventEntry(this.editedItem);
      this.close();
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    'event._id': {
      handler(newId) {
        // Nur laden wenn ID vorhanden ist
        if (newId) {
          console.log('Event ID available/changed, loading invoices:', newId);
          this.getInvoices(newId);
        }
      },
      immediate: true
    }
  },
  mounted() {
    // Invoices werden jetzt über den event._id watcher geladen
    console.log('DatatableInvoices mounted');
  },
  computed: {
    ...mapGetters(['loadingInvoices']),
    estimatedRefreshTime() {
      let invoices = this.invoices.filter(
        (invoice) => invoice.state == "approved"
      ).length;
      if (invoices >= 60) {
        return Math.round(invoices / 60).toString() + " Minuten";
      }
      return Math.round(invoices).toString() + " Sekunden";
    },
    formTitle() {
      return "Rechnungsdaten Anmelder";
    },
    pages() {
      return this.pagination.rowsPerPage
        ? Math.ceil(this.items.length / this.pagination.rowsPerPage)
        : 0;
    },
  },
};
</script>

<style>
/* Unscoped damit Vuetify DataTable-Klassen erreicht werden */
.table-row-canceled {
  background-color: rgba(255, 76, 81, 0.08) !important;
}

.table-row-canceled:hover {
  background-color: rgba(255, 76, 81, 0.15) !important;
}

.table-row-canceled td {
  color: #dc3545 !important;
}

/* Alternative mit Deep Selector falls benötigt */
.v-data-table >>> .table-row-canceled {
  background-color: rgba(255, 76, 81, 0.08) !important;
}

.v-data-table >>> .table-row-canceled:hover {
  background-color: rgba(255, 76, 81, 0.15) !important;
}

.v-data-table >>> .table-row-canceled td {
  color: #dc3545 !important;
}
</style>
